import { tv } from 'tailwind-variants'

export const documentCardVariants = tv({
  slots: {
    container: 'flex flex-col bg-white rounded-none rounded-t-mili p-mili'
  },
  variants: {
    source: {
      CLIENT: {
        container: 'rounded-br-mili'
      },
      PRODUCT: {
        container: 'rounded-bl-mili'
      }
    },
    isReply: {
      true: {
        container: 'rounded-t-none rounded-br-none rounded-bl-none '
      }
    }
  }
})
